/*
 *
 * PagoPaDownloadAllPopup
 *
 * @version 1.0.0
 * @author Emanuele Motta
 * @since 10-Dec-2025
*/

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  title: (
    <PortalMessage
      id='t.app.pagoPa.downloadAllPopup.title'
      defaultMessage='Scarica tutti i pagamenti'
    />
  ),
  close: (
    <PortalMessage
      id='t.app.close'
      defaultMessage='Chiudi'
    />
  ),
  primaryButtonLabel: (
    <PortalMessage
      id='t.app.transactions.downloadAllPopup.primaryButtonLabel'
      defaultMessage='Scarica CSV'
    />
  ),
  secondaryButtonLabel: (
    <PortalMessage
      id='t.app.transactions.downloadAllPopup.secondaryButtonLabel'
      defaultMessage='Scarica XLS'
    />
  ),
  formatInfoMessage: (
    <PortalMessage
      id='t.app.pagoPa.downloadAllPopup.formatInfoMessage'
      defaultMessage='Seleziona il formato di file che preferisci. '
    />
  )
}

export default formattedMessage
